'use client';

import { notFound } from 'next/navigation';
import { useAuth } from '@/contexts/auth-context';
import { isDevToolsAllowedForEmail } from '../constants';

export function DevToolsGuard({ children }: { children: React.ReactNode }) {
  const { user, status } = useAuth();

  if (status === 'loading') return null;

  if (!isDevToolsAllowedForEmail(user?.email)) {
    notFound();
  }

  return <>{children}</>;
}
